import Swiper from 'swiper/bundle';

(function ($) {
    let swiper = new Swiper(".section-slider-images-text-type-2 .slider-images-text", {
        slidesPerView: 'auto',
        spaceBetween: 24,
        navigation: {
            nextEl: ".section-slider-images-text-type-2 .swiper-button-next",
            prevEl: ".section-slider-images-text-type-2 .swiper-button-prev",
        },
        scrollbar: {
            el: '.section-slider-images-text-type-2 .swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            300: {
                spaceBetween: 16,
            },
            767: {
                spaceBetween: 20,
            },
            1439: {
                spaceBetween: 24,
            },
        }
    });
})(jQuery);